import { BaseResource, ResourceActionV2, UuidResourceParam } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

export const shippingOrderResource = BaseResource(["shipping", "orders"], {
  fastestDeliveryDate: ResourceActionV2({
    name: "fastestDeliveryDate",
    method: "get",
    responseValueSerializer: MSerializers.dateOnly,
  }),
});
